import { STORE_GETTER } from "../store/store"




export const settingsMixin = {

	computed: {

		settingList() {
			return this.$store.getters[STORE_GETTER.BASE_MODEL]?.settingList
		}


	},

	methods: {

		

		getSettingValue(key) {


			if (this.settingList) {


				const setting = this.settingList?.find(setting => setting.key?.toUpperCase() == key?.toUpperCase())
				
				if (setting){

					if (setting.type == "Boolean"){
						return setting.value === "true" || setting.value == true
					}

					return setting.value;
					
				}

			}

			return null;
		}

	}
}



